export default function linedirection() {
    const button = document.querySelector('#spv-reverseButton');
    const list = document.querySelector('#spv-list');
    const unreversedNameOfStation = (document.querySelector('#unreversed-station-name'));
    const reversedNameOfStation = (document.querySelector('#reversed-station-name'));
    function toggleDirection() {
        let i = 0;
        if (list) {
            i = list.childNodes.length;
            while (i--)
                list.appendChild(list?.childNodes[i]);
        }
        if (unreversedNameOfStation.style.display === 'none') {
            unreversedNameOfStation.style.display = 'block';
        }
        else {
            unreversedNameOfStation.style.display = 'none';
        }
        if (reversedNameOfStation.style.display === 'block') {
            reversedNameOfStation.style.display = 'none';
        }
        else {
            reversedNameOfStation.style.display = 'block';
        }
    }
    button?.addEventListener('click', toggleDirection);
}
linedirection();
//# sourceMappingURL=line-direction.js.map